"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFileProtocol = isFileProtocol;
var _runtime = require("../constants/runtime");
/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

function isFileProtocol() {
  return Boolean(_runtime.globalScope?.location?.protocol === 'file:');
}